


















































































































import Vue, { PropType } from "vue";
import { Project } from "@/types";
import { isFinishedLock } from "@/util/project-style";

import _ from "underscore";

export default Vue.extend({
  components: {},
  props: {
    value: {
      type: Object as PropType<Project>
    },
    rules: {
      type: Object,
      default: () => []
    },
    autofocus: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      accountManagerName: ""
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val && val.accountManagerName && val.zmCustomer === "wocozon") {
          this.accountManagerName = val.accountManagerName;
        } else if (
          val &&
          val.housingCooperativeId &&
          val.zmCustomer === "wocozon"
        ) {
          this.accountManagerName = this.getAccountManager(
            val.housingCooperativeId
          );
        } else {
          this.accountManagerName = "";
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    getAccountManager(id: number): string {
      const hoco = this.housingCooperatives.find(hoco => hoco.id === id);
      return hoco?.accountManagerName || "";
    }
  },

  computed: {
    locked(): boolean {
      return isFinishedLock(this.value);
    },
    projectManagers():{ id: number | string; name: string }[] {
      const listed: { id: number | string; name: string }[] = _.sortBy(
        this.$store.state.dictionaries.projectManagers.items,
        "name"
      );
      // The list is the Azure group ZONE_PM (WOC-7977). A manager who left the group keeps
      // the project, so they stay selectable here — otherwise the select shows nothing for a
      // project that does have a manager, and the form cannot be saved.
      const current = this.value?.projectManagerId;
      if (current && !listed.some(item => item.id === current)) {
        return [
          { id: current, name: this.value.projectManagerName || String(current) },
          ...listed
        ];
      }
      return listed;
    },
    housingCooperatives(): any[] {
      return _.sortBy(
        this.$store.state.dictionaries.housingCooperatives.items,
        "name"
      );
    },
    zonmaatUsers(): unknown[] {
      return _.sortBy(
        this.$store.state.dictionaries.zonmaatUsers.items,
        "name"
      );
    },
    installers(): unknown[] {
      return _.sortBy(this.$store.state.dictionaries.installers.items, "name");
    }
  }
});
